import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsJobComponent extends Component {
  // Services
  @service data;

  // Defaults
  employmentTypes = [
    'FULL_TIME',
    'PART_TIME',
    'CONTRACTOR',
    'TEMPORARY',
    'INTERN',
    'VOLUNTEER',
    'PER_DIEM',
    'OTHER',
  ];

  // Getter and setter
  get employmentTypeOptions() {
    return labelValueOptions.call(this, this.employmentTypes, [
      'forms.job.options.employmentType',
    ]);
  }

  get jobTypeOptions() {
    return this.resolvedJobTypeOptions.value ?? [];
  }

  get jobFunctionsOptions() {
    return this.resolvedJobFunctionsOptions.value ?? [];
  }

  // Functions
  resolvedJobTypeOptions = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'JOB_TYPE' });
  });

  resolvedJobFunctionsOptions = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'JOB_FUNCTION' });
  });

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='content' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field @property='subHeadline' />

            <fieldset.field
              @property='text'
              @type='text-editor'
              @textEditorHeight='600'
            />
          </form.fieldset>

          <form.fieldset @titleKey='keywords' as |fieldset|>
            <fieldset.field @property='keywords' />
          </form.fieldset>

          <form.sections.seo as |fieldset|>
            <fieldset.field
              @property='employmentType'
              @type='select-multiple'
              @options={{this.employmentTypeOptions}}
            />
          </form.sections.seo>
        </:content>

        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}
          </form.fieldset>

          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='category'
              @type='select-record'
              @options={{this.jobTypeOptions}}
            />

            <fieldset.field
              @property='jobFunctions'
              @type='select-multiple'
              @labelProperty='displayLabel'
              @selectPath={{false}}
              @options={{this.jobFunctionsOptions}}
            />
            <fieldset.field
              @property='channel'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
            <fieldset.field
              @property='division'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
            <fieldset.field
              @property='link'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
            <fieldset.field
              @property='label'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @property='asset'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
            <fieldset.field
              @property='location'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
          </form.fieldset>

          <form.fieldset
            @titleKey='taxonomies'
            @isClosed={{true}}
            as |fieldset|
          >
            <fieldset.field @property='taxa' @type='has-many' />
          </form.fieldset>

          <form.fieldset @titleKey='controls' @isClosed={{true}} as |fieldset|>
            <fieldset.field @property='cmsLivedate' @type='date-time' />
            <fieldset.field @property='cmsKilldate' @type='date-time' />
          </form.fieldset>

          <form.sections.meta />
        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
